<template>
  <div v-if="display.visible" class="emoji-picker">
    <div class="emoji-picker__search">
      <input type="text" v-model="search" v-focus />
      <span class="emoji-close" @click="display.visible = false"><i class="fas fa-times"></i></span>
    </div>
    <div>
      <div v-for="(emojiGroup, category) in emojis" :key="category">
        <h5>{{ category }}</h5>
        <div class="emojis">
          <span
            v-for="(emoji, emojiName) in emojiGroup"
            :key="emojiName"
            @click="insert(emoji)"
            :title="emojiName"
            >{{ emoji }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import emojis from './emojis'
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
const escapeRegExp = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
export default {
  name: 'emoji-widget',
  props: {
    search: {
      type: String,
      required: false,
      default: ''
    },
    emojiTable: {
      type: Object,
      required: false,
      default() {
        return emojis
      }
    }
  },
  data() {
    return {
      display: {
        x: 0,
        y: 0,
        visible: false
      }
    }
  },
  mounted() {
    document.addEventListener('keyup', this.escape)
  },
  computed: {
    emojis() {
      if (this.search) {
        const obj = {}
        for (const category in this.emojiTable) {
          obj[category] = {}
          for (const emoji in this.emojiTable[category]) {
            if (new RegExp(`.*${escapeRegExp(this.search)}.*`).test(emoji)) {
              obj[category][emoji] = this.emojiTable[category][emoji]
            }
          }
          if (Object.keys(obj[category]).length === 0) {
            delete obj[category]
          }
        }
        return obj
      }
      return this.emojiTable
    }
  },
  methods: {
    insert(emoji) {
      this.$emit('emoji', emoji)
    },
    toggle(e) {
      this.display.visible = !this.display.visible
    },
    hide() {
      this.display.visible = false
    },
    escape(e) {
      if (this.display.visible === true && e.keyCode === 27) {
        this.display.visible = false
      }
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  },
  destroyed() {
    document.removeEventListener('keyup', this.escape)
  }
}
</script>
<style lang="scss" scoped>
.emoji-close {
  position: absolute;
  right: 5px;
  top: 0;
  i {
    font-size: 1.1em;
    cursor: pointer;
  }
}
.emoji-picker {
  position: absolute;
  z-index: 99;
  border: 1px solid #ccc;
  width: 15rem;
  height: 20rem;
  overflow-y: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  -webkit-box-shadow: 1px 1px 8px #c7dbe6;
  box-shadow: 1px 1px 8px #c7dbe6;
  bottom: 70px;
  left: 5px;
  overflow-x: hidden;
  padding: 5px;
}
.emoji-picker__search {
  display: flex;
  position: relative;
}
.emoji-picker__search > input {
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 0;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: '';
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/emoji/emoji-widget.vue